import React from "react";
import { useAppSelector } from "common/hooks/storeHooks";
import { accessIds } from "common/selectors/access.selectors";
import { CustomLink } from "common/components/CustomLink";
import { Button } from "common/components/Button";
import { Empty } from "common/components/Empty";
import { useNavigate, useSearchParams } from "react-router";

interface UnauthorizedProps {
  showHomeAction?: boolean;
}

export const Unauthorized: React.FC<UnauthorizedProps> = ({ showHomeAction = true }) => {
  const ids = useAppSelector(accessIds);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dvhSupported = CSS.supports("(height: 100dvh)");

  return (
    <div className={`w-screen ${dvhSupported ? "h-[100dvh]" : "h-screen"} flex justify-center items-center`}>
      <Empty
        title="403"
        description="Sorry, the requested resource does not exist or you do not have permission to view.">
        {showHomeAction && (
          <div className="flex gap-md">
            {ids.size > 1 && (
              <CustomLink
                href={"/orgs/accesses" + (searchParams.toString() ? `?${searchParams.toString()}` : "")}
                className="inline-flex">
                <Button analyticsAction="request-access" variant="primary">
                  Choose Organization
                </Button>
              </CustomLink>
            )}
            <Button analyticsAction="unauthorized-home" variant="secondary" onClick={() => navigate("/jobs")}>
              Go Home
            </Button>
          </div>
        )}
      </Empty>
    </div>
  );
};
